import PopUpMessage from "../Common/PopUpMessages/PopUpMessage";
import WorkerStatusBar from "../Common/WorkerStatusBar";
import * as PropTypes from "prop-types";
import DashboardCard from "../DashboardCard";
import {activeColors, colors, plainColors} from "../UIElements/Elements";


DashboardCard.propTypes = {title: PropTypes.string};
const WorkerDashboard = () => {
    return (
        <div
            className={`w-screen h-[92vh] top-[8vh] absolute flex flex-col items-center justify-evenly ${plainColors.light} text-white overflow-hidden flex-wrap bg-center mx-[1vh]`}>
            <WorkerStatusBar workerName={"Dardan Asani"} outletName={"Garden"}/>
            <PopUpMessage/>
            <DashboardCard title={"POS (Point of sale)"}/>
            <DashboardCard title={"Accounting"}/>
            <DashboardCard title={"Inventory Management"}/>
            <DashboardCard title={"Supplier Management"}/>
            <DashboardCard title={"Employee Management"}/>
            <DashboardCard title={"Reports & Analytics"}/>

        </div>
    );
}

export default WorkerDashboard;
